// extracted by mini-css-extract-plugin
module.exports = {"footerSection":"Footer_footerSection__kRzur","content":"Footer_content__FkdZu","links":"Footer_links__Zx2Bs","disclaimer":"Footer_disclaimer__C6O3q","logo":"Footer_logo__9qCeu"};